'use client';

import { useRouter } from 'next/navigation';
import UIButton from 'components/buttons/UIButton';

interface AddToCartButtonProps {
  isInCart: boolean;
  onAddToCart: () => void;
  fullWidth?: boolean;
  isMobile?: boolean;
  isPending?: boolean;
}

export default function AddToCartButton({
  isInCart,
  onAddToCart,
  fullWidth = false,
  isMobile = false,
  isPending = false,
}: AddToCartButtonProps) {
  const router = useRouter();

  const inCartLabel = isMobile ? 'View cart' : 'Plan added - view cart';
  const label = isPending
    ? 'Adding...'
    : isInCart
    ? inCartLabel
    : 'Add plan to cart';

  return (
    <>
      <UIButton
        buttonType="primary"
        label={label}
        onClick={isInCart ? () => router.push('/cart') : onAddToCart}
        fullWidth={fullWidth}
        disabled={isPending}
      />
      {/* For screen readers */}
      <span role="status" className="visually-hidden">
        {isPending ? 'Adding plan to cart' : isInCart ? 'Added to cart' : ''}
      </span>
    </>
  );
}
